import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 1024px) {
    flex-direction: column;
  }

  p {
    font-size: 20px;
    line-height: 26px;
    margin-left: 19px;

    @media (max-width: 1024px) {
      margin-top: 24px;
      font-size: 14px;
      line-height: 18px;
      margin-left: 16px;
    }
  }

  img {
    margin-top: 6px;
    width: 200px;
    height: 200px;

    @media (max-width: 1024px) {
      margin-left: 16px;
    }
  }
`;

const HRoss = (props) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <img src={require('assets/images/houston-ross.png')} alt="" />
      <p>
        Houston has years of experience leading global organizations in preparing for the future,
        modernizing operations and infrastructure, and developing teams to perform at a high level.
        Most recently Houston was the CTO for Japan BNPL-unicorn Paidy, leading the organization
        towards a successful public exit.
        <br />
        <br />
        A global leader, Houston has held the role of CTO for Global Finance Organizations such as
        AXA Life, ING, and NN.
        <br />
        <br />A sports enthusiast, he aims to leverage his experience in technology, finance, and
        operational excellence to make P4P a global leader.
      </p>
    </Wrapper>
  );
};

export default HRoss;
